import React from 'react';
type Tone = 'light' | 'dark';
export function Eyebrow({
  children,
  tone = 'light',
  align = 'center'
}: {
  children: React.ReactNode;
  tone?: Tone;
  align?: 'center' | 'left';
}) {
  return <p className={`mb-3 font-display text-xs font-extrabold uppercase tracking-[.18em] md:text-sm ${align === 'center' ? 'text-center' : 'text-left'} ${tone === 'dark' ? 'text-gold' : 'text-forest'}`} data-id="element-255" data-mp="2vxarwwrr3qtv">
      {children}
    </p>;
}
export function SectionTitle({
  children,
  tone = 'light'
}: {
  children: React.ReactNode;
  tone?: Tone;
}) {
  return <h2 className={`mx-auto max-w-4xl text-center font-display text-2xl font-black uppercase leading-tight md:text-4xl ${tone === 'dark' ? 'text-ivory' : 'text-charcoal'}`} data-id="element-256" data-mp="30y8ermnph91p">
      {children}
    </h2>;
}
export function SectionLead({
  children,
  tone = 'light'
}: {
  children: React.ReactNode;
  tone?: Tone;
}) {
  return <p className={`mx-auto mt-4 max-w-2xl text-center text-base leading-relaxed md:text-lg ${tone === 'dark' ? 'text-ivory/80' : 'text-charcoal/75'}`} data-id="element-257" data-mp="1gh2bbbt4u6bo">
      {children}
    </p>;
}
export function Mark({
  children
}: {
  children: React.ReactNode;
}) {
  return <span className="bg-sand/70 box-decoration-clone px-1.5 text-charcoal" data-id="element-258" data-mp="2ejfpnovjku15">{children}</span>;
}